import { Section } from './page.model';

export const categories = ['wedding', 'family', 'newborn', 'maternity'];

export interface Category {
  id?: string;
  title: string;
  subTitle: string;
  content: Section[];
}
